@file:Suppress(
    "RETURN_VALUE_NOT_USED",
    "RETURN_VALUE_NOT_USED_COERCION",
)

import com.varabyte.kobweb.core.AppGlobals
import com.varabyte.kobweb.navigation.BasePath
import com.varabyte.kobweb.navigation.Router
import com.varabyte.kobweb.navigation.UpdateHistoryMode
import com.varabyte.kobweb.navigation.remove
import com.varabyte.kobweb.silk.defer.DeferringHost
import kotlin.Suppress
import kotlinx.browser.document
import kotlinx.browser.window
import org.jetbrains.compose.web.renderComposable
import com.example.site.components.layouts.MarkdownLayout as _com_example_site_components_layouts_MarkdownLayout
import com.example.site.components.layouts.PageLayout as _com_example_site_components_layouts_PageLayout
import com.example.site.pages.AboutPage as _com_example_site_pages_AboutPage
import com.example.site.pages.HomePage as _com_example_site_pages_HomePage
import com.example.site.pages.blog.BlogPage as _com_example_site_pages_blog_BlogPage
import com.example.site.pages.english.AboutPage as _com_example_site_pages_english_AboutPage
import com.example.site.pages.me.AboutPage as _com_example_site_pages_me_AboutPage

public fun main() {
    AppGlobals.initialize(mapOf("title" to "My Site"))
    BasePath.set("")
    val router = Router()
    com.varabyte.kobweb.core.init.initKobweb(router) { ctx ->
        ctx.router.registerLayout(
            "com.example.site.components.layouts.MarkdownLayout",
        ) { pageCtx, pageMethod -> 
            _com_example_site_components_layouts_MarkdownLayout {
                pageMethod(pageCtx)
            }
        }
        ctx.router.registerLayout(
            "com.example.site.components.layouts.PageLayout",
        ) { pageCtx, pageMethod -> 
            _com_example_site_components_layouts_PageLayout {
                pageMethod(pageCtx)
            }
        }
        ctx.router.register(
            "/",
        ) { pageCtx -> 
            _com_example_site_pages_HomePage()
        }
        ctx.router.register(
            "/about",
            layoutId = "com.example.site.components.layouts.MarkdownLayout",
            initRouteMethod = { ctx ->
                com.example.site.pages.initAboutPage(ctx)
            },
        ) { pageCtx -> 
            _com_example_site_pages_AboutPage()
        }
        ctx.router.register(
            "/blog/",
        ) { pageCtx -> 
            _com_example_site_pages_blog_BlogPage()
        }
        ctx.router.register(
            "/english/",
        ) { pageCtx -> 
            _com_example_site_pages_english_AboutPage()
        }
        ctx.router.register(
            "/me/",
        ) { pageCtx -> 
            _com_example_site_pages_me_AboutPage()
        }

    }
    router.addRouteInterceptor {
        path = path.removeSuffix(".html").removeSuffix(".htm")
    }

    com.varabyte.kobweb.silk.init.additionalSilkInitialization = { ctx ->
        com.varabyte.kobweb.silk.init.initSilkWidgets(ctx)
        com.varabyte.kobweb.silk.init.initSilkWidgetsKobweb(ctx)
        ctx.theme.registerStyle("headline-text", com.example.site.HeadlineTextStyle)
        ctx.theme.registerStyle("subheadline-text", com.example.site.SubheadlineTextStyle)
        ctx.theme.registerVariant("-circle", com.example.site.CircleButtonVariant)
        ctx.theme.registerVariant("-uncolored", com.example.site.UncoloredButtonVariant)
        com.example.site.initSiteStyles(ctx)
        com.example.site.initTheme(ctx)
        com.example.site.initColorMode(ctx)
        com.example.site.initStyles(ctx)
    }

    // Dedup any leading slashes after removing the origin, just in case someone typed
    // something like `https://site.com//about` by accident. If we pass `//about` into
    // `tryRoutingTo`, Kobweb will reject it as a protocol-relative URL; instead, we
    // want it to navigate to `/about`
    router.tryRoutingTo(BasePath.remove("/" + window.location.href.removePrefix(window.origin).trimStart('/')), UpdateHistoryMode.REPLACE)

    // For SEO, we may bake the contents of a page in at build time. However, we will
    // overwrite them the first time we render this page with their composable, dynamic
    // versions. Think of this as poor man's hydration :)
    // See also: https://en.wikipedia.org/wiki/Hydration_(web_development)
    val root = document.getElementById("_kobweb-root")!!
    while (root.firstChild != null) { root.removeChild(root.firstChild!!) }

    renderComposable(rootElementId = "_kobweb-root") {
        com.example.site.AppEntry {
            router.renderActivePage { DeferringHost { it() } }
        }
    }
}
